/* eslint-disable import/first */
import { Suspense, lazy } from "react";
const LazyLandingPage = lazy(() => import("./Pages/LandingPage/LandingPage"));
// eslint-disable-next-line import/first
import {
  createBrowserRouter,
  Link,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "./SASS/styles.scss";

import { Layout, Loader, NotFound } from "./MainComponents";
import {
  SignIn,
  Register,
  StudentLectures,
  StudentChapter,
  StudentLecture,
  Exams,
  SingleExamPage,
  HomePage,
  StudentQuestionBank,
  QuizNew,
  StudentShowQuestionBank,
  Profile,
  // Amount,
} from "./Pages/Student";
import {
  AdminLayout,
  Posts,
  AddEditPost,
  Students,
  EditStudent,
  Attendance,
  AdminLectures,
  AddEditChapter,
  AddEditLecture,
  Videos,
  AdminMaterials,
  AddEditMaterial,
  AddEditVideo,
  AdminChapter,
  AdminLecture,
  AdminQuiz,
  AdminExams,
  Groups,
  AddEditGroup,
  Codes,
  Requests,
  SessionStudents,
  SessionAbsence,
  Assistants,
  AddEditAssistant,
  QuestionBank,
  QuestionBankCategory,
  AddEditEssayQuestion,
  AddEditChooseQuestion,
  AddEditCategory,
  Whatsapp,
  ViewStudent,
  CodesTracker,
  AdminProfile,
  AdminAddEditExam,
  AdminViewExam,
  AdminAddStudentLecture,
  AdminCorrection,
  AdminStudentCorrection,
  AdminQuestionCorrection,
  AdminQuestionCorrectionForm,
  AttendanceAddSession,
  Reviews,
  Accounting,
} from "./Pages/Admin";

import ProtectedAdminRoutes from "./MainComponents/ProtectionComponents/ProtectedAdminRoutes";
import { useAuthState } from "./MainComponents/GlobalContext.jsx";
import ModalAnswer from "./Pages/Student/Lectures/modalAnswer/ModalAnswer";
import AdminModalAnswer from "./Pages/Admin/Dashboard/Exams/AdminModalAnswer.jsx";
import ForgetPassword from "./Pages/Student/SignIn/ForgetPassword.jsx";
import PrivacyPolicyPage from "./Pages/Student/PrivacyPolicy/PrivacyPolicy.jsx";
import PublicLectures from "./Pages/Student/PublicLectures/PublicLectures.jsx";
import PublicLecture from "./Pages/Student/PublicLectures/PublicLecture.jsx";
import PublicChapter from "./Pages/Student/PublicLectures/PublicChapter.jsx";
import Transaction from "./Pages/Admin/Dashboard/Transaction/Transaction.jsx";
import TermsCondition from "./Pages/Student/Terms/TermsCondition.jsx";
import RefundCancellation from "./Pages/Student/RefundCancellation/RefundCancellation.jsx";
import { Purchases } from "./Pages/Student/Purchases/Purchases.jsx";

function App() {
  const AuthState = useAuthState();

  const router = createBrowserRouter([
    //!--------Landing Page Layout--------
    {
      path: "/",
      element: (
        <ProtectedAdminRoutes
          redirectPath={`${
            AuthState.userData?.admin?.roles[0]?.name === "superadmin"
              ? "/admin/students"
              : AuthState.userData?.admin?.permissions?.length > 0
                ? `/admin/${AuthState.userData?.admin?.permissions[0]?.section?.toLowerCase()}`
                : "/lectures"
          }`}
          isAllowed={!AuthState.userData}
        >
          <Suspense fallback={<Loader />}>
            <LazyLandingPage />
          </Suspense>
        </ProtectedAdminRoutes>
      ),
    },
    //!Student Layout
    {
      element: (
        <ProtectedAdminRoutes
          redirectPath="/signin"
          isAllowed={AuthState.userData?.student_token}
        >
          <Layout />
        </ProtectedAdminRoutes>
      ),
      children: [
        // {
        //   path: "/home",
        //   element: <HomePage />,
        // },
        {
          path: "/home/profile",
          element: <Profile />,
        },
        // {
        //   path: "/home/amount",
        //   element: <Amount />,
        // },

        {
          path: "/lectures",
          element: <StudentLectures />,
        },
        {
          path: "/lectures/chapters/:chapterID",
          element: <StudentChapter />,
        },
        {
          path: "/lectures/sessions/:lectureID",
          element: <StudentLecture />,
        },
        {
          path: "/lectures/sessions/modalAnswer/:lectureID",
          element: <ModalAnswer />,
        },
        {
          path: "/exams",
          element: <Exams />,
        },
        {
          path: "/exams/:examID",
          element: <SingleExamPage />,
        },
        {
          path: "/exams/solve-exam/:ID",
          element: <QuizNew exam />,
        },
        {
          path: "/exams/modal-answer/:ID",
          element: <ModalAnswer exam />,
        },
        //!Quiz
        {
          path: "/home/quiz/:ID",
          element: <QuizNew />,
        },
        //!Homework
        {
          path: "/home/homework/:ID",
          element: <QuizNew homework />,
        },
        //! Student Question Bank
        {
          path: "/home/question-bank",
          element: <StudentQuestionBank />,
        },
        {
          path: "/home/question-bank/:ID",
          element: <StudentShowQuestionBank />,
        },
        //!My Puchases
        {
          path: "/purchases",
          element: <Purchases />,
        },
      ],
    },
    //!Admin Layout
    {
      element: (
        <ProtectedAdminRoutes
          redirectPath="/not-found"
          isAllowed={
            AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
            AuthState.userData?.admin?.permissions?.length > 0
          }
        >
          <AdminLayout />
        </ProtectedAdminRoutes>
      ),
      children: [
        //!--------- dashboard Routes --------------
        {
          path: "/admin/students",
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.section.startsWith("Students")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/students",
              element: <Students />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("post_edit")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/dashboard/edit-post/:postID",
              element: <AddEditPost edit />,
            },
          ],
        },
        //!------ students Routes --------------

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("student")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/students",
              element: <Students />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("students")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/students/add-student",
              element: <Register addNew />,
            },

            {
              path: "/admin/students/edit-student/:studentID",
              element: <EditStudent />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("students")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/students/view-student/:studentID",
              element: <ViewStudent />,
            },
            {
              path: "/admin/center-students/view-student/:studentID",
              element: <ViewStudent />,
            },
          ],
        },
        //!------ Attendance Routes --------------

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("attendance")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/attendance",
              element: <Attendance />,
            },
            {
              path: "/admin/attendance/:lectureID/add-session",
              element: <AttendanceAddSession />,
            },
            {
              path: "/admin/attendance/:lectureID/edit-session/:sessionID",
              element: <AttendanceAddSession edit />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("attendance")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/attendance/:groupID/:lectureID",
              element: <SessionStudents />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("attendance")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/attendance/:groupID/:lectureID/absence",
              element: <SessionAbsence />,
            },
          ],
        },
        //!------ Lectures Routes --------------

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("content")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses",
              element: <AdminLectures />,
            },
          ],
        },

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("content")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/add-course",
              element: <AddEditChapter />,
            },
            {
              path: "/admin/courses/add-lecture",
              element: <AddEditLecture />,
            },
            {
              path: "/admin/courses/:chapterID/add-lecture",
              element: <AddEditLecture />,
            },
          ],
        },

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("content")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/edit-course/:chapterID",
              element: <AddEditChapter edit />,
            },
            {
              path: "/admin/courses/edit-lecture/:lectureID",
              element: <AddEditLecture edit />,
            },
          ],
        },

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("content")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/chapters/:chapterID",
              element: <AdminChapter />,
            },
            {
              path: "/admin/courses/sessions/:lectureID",
              element: <AdminLecture />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("add_student_to_courses")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/sessions/:lectureID/add-student",
              element: <AdminAddStudentLecture />,
            },
          ],
        },
        //!--- lecture_addvideos ---
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("content")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/sessions/:lectureID/videos",
              element: <Videos />,
            },
            {
              path: "/admin/courses/:lectureID/add-video",
              element: <AddEditVideo />,
            },
            {
              path: "/admin/videos/edit-video/:VideoID",
              element: <AddEditVideo edit />,
            },
          ],
        },
        //!--- lecture_addmatrial ---
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("content")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/sessions/:lectureID/materials",
              element: <AdminMaterials />,
            },
            {
              path: "/admin/courses/:lectureID/add-material",
              element: <AddEditMaterial />,
            },
          ],
        },
        //!--- lecture_quiz ---

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("lecture_addquiz")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/sessions/:lectureID/quiz",
              element: <AdminQuiz />,
            },
            {
              path: "/admin/courses/sessions/quiz/edit-essay-question/:questionID",
              element: <AddEditEssayQuestion edit lectureQuestion />,
            },
            {
              path: "/admin/courses/sessions/quiz/edit-choose-question/:questionID",
              element: <AddEditChooseQuestion edit lectureQuestion />,
            },
          ],
        },

        //!---- Accounting ---
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin"
              }
            />
          ),
          children: [
            {
              path: "/admin/accounting",
              element: <Accounting />,
            },
          ],
        },

        //!---- Transaction ---
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={AuthState.userData?.admin}
            />
          ),
          children: [
            {
              path: "/admin/transaction",
              element: <Transaction />,
            },
          ],
        },
        //!--- Correction ----
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("correction")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/correction",
              element: <AdminCorrection />,
            },
            {
              path: "/admin/correction/:studentID",
              element: <AdminStudentCorrection />,
            },
            {
              path: "/admin/correction/:studentID/:correctionType/:examId",
              element: <AdminQuestionCorrection />,
            },
            {
              path: "/admin/correction/:studentID/:correctionType/:examId/correction-student/:questionId",
              element: <AdminQuestionCorrectionForm />,
            },
          ],
        },
        //!--- lecture_homework ---

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("lecture_addHw")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/courses/sessions/:lectureID/homework",
              element: <AdminQuiz homework />,
            },
            {
              path: "/admin/courses/sessions/homework/edit-essay-question/:questionID",
              element: <AddEditEssayQuestion edit lectureQuestion />,
            },
            {
              path: "/admin/courses/sessions/homework/edit-choose-question/:questionID",
              element: <AddEditChooseQuestion edit lectureQuestion />,
            },
          ],
        },

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("exam")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/exams",
              element: <AdminExams />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("exam_add")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/exams/add-exam",
              element: <AdminAddEditExam />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("exam_edit")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/exams/edit-exam/:ID",
              element: <AdminAddEditExam edit />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("exam_view")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/exams/all-students/:examID",
              element: <AdminViewExam />,
            },
            {
              path: "/admin/exams/all-students/:examID/model-answer",
              element: <AdminModalAnswer />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("exam_addquestions")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/exams/:examID",
              element: <AdminQuiz exam />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("questionbank")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/question-bank",
              element: <QuestionBank />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith(
                    "questionbank_viewquestionbycategory"
                  )
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/question-bank/:categoryID",
              element: <QuestionBankCategory />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("questionbank_addcategory")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/question-bank/add-category",
              element: <AddEditCategory />,
            },
            {
              path: "/admin/question-bank/edit-category/:categoryID",
              element: <AddEditCategory edit />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("questionbank_addquestion")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/question-bank/:categoryID/add-essay-question",
              element: <AddEditEssayQuestion />,
            },
            {
              path: "/admin/question-bank/:categoryID/add-choose-question",
              element: <AddEditChooseQuestion />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("questionbank_editquestion")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/question-bank/:categoryID/edit-essay-question/:questionID",
              element: <AddEditEssayQuestion edit />,
            },
            {
              path: "/admin/question-bank/:categoryID/edit-choose-question/:questionID",
              element: <AddEditChooseQuestion edit />,
            },
          ],
        },

        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("groups")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/groups",
              element: <Groups />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("groups")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/groups/add-group",
              element: <AddEditGroup />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("groups")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/groups/edit-group",
              element: <AddEditGroup />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("codes")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/codes",
              element: <Codes />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("codes")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/codes-tracker",
              element: <CodesTracker />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("request")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/requests",
              element: <Requests />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={true}
              // isAllowed={
              //   AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              //   AuthState.userData?.admin?.permissions?.some((permission) =>
              //     permission.name.startsWith("request_accept")
              //   )
              // }
            />
          ),
          children: [
            {
              path: "/admin/profile",
              element: <AdminProfile />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("user")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/assistants",
              element: <Assistants />,
            },
            {
              path: "/admin/assistants/add-assistant",
              element: <AddEditAssistant />,
            },
            {
              path: "/admin/assistants/edit-assistant/:assistantID",
              element: <AddEditAssistant edit />,
            },
          ],
        },
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("whatsapp_show")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/whatsapp",
              element: <Whatsapp />,
            },
          ],
        },
        //!---- reviews route ----
        {
          element: (
            <ProtectedAdminRoutes
              redirectPath="/not-found"
              isAllowed={
                AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
                AuthState.userData?.admin?.permissions?.some((permission) =>
                  permission.name.startsWith("reviews")
                )
              }
            />
          ),
          children: [
            {
              path: "/admin/reviews",
              element: <Reviews />,
            },
          ],
        },
      ],
    },
    //!SignIn-routes
    {
      element: (
        <ProtectedAdminRoutes
          redirectPath={`${
            AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
            AuthState.userData?.admin?.permissions?.length > 0
              ? "/admin/students"
              : "/lectures"
          }`}
          isAllowed={!AuthState.userData}
        />
      ),
      children: [
        //!SignIn

        {
          path: "/signin",
          element: <SignIn />,
        },
        {
          path: "/register",
          element: <Register addNew student />,
        },
        {
          path: "/forget-password",
          element: <ForgetPassword />,
        },
        {
          path: "/admin/signin",
          element: <SignIn admin />,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicyPage />,
        },
        {
          path: "/terms-conditions",
          element: <TermsCondition />,
        },
        {
          path: "/refund-cancellation-policy",
          element: <RefundCancellation />,
        },
        {
          path: "/public-lectures",
          element: <PublicLectures />,
        },
        {
          path: "/public-lectures/chapters/:chapterID",
          element: <PublicChapter />,
        },
        {
          path: "/public-lectures/sessions/:lectureID",
          element: <PublicLecture exam />,
        },

        //!Register
        // {
        //   path: "/register",
        //   element: <Register />,
        // },
      ],
    },

    //!NotFound
    {
      path: "/not-found",
      element: <NotFound />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);
  return (
    <main className="dar:text-light text-secondary duration-100 dark:bg-dark">
      <RouterProvider router={router} fallbackElement={<Loader />} />
    </main>
  );
}

export default App;
